/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'extension.charts.aggregateData': 'Aggregate data',
  'extension.charts.aggregateDataDescription':
    'Combine values into a single data point when multiple rows have the same value.',
  'extension.charts.category': 'Category',
  'extension.charts.customizeTab': 'Customize',
  'extension.charts.dataMissing.details': 'We can’t find this chart’s source table on the page.',
  'extension.charts.dataMissing.title': 'No data to display',
  'extension.charts.dataTab': 'Data',
  'extension.charts.defaultColumnName': 'Column {0}',
  'extension.charts.defaultTitle': 'Untitled chart',
  'extension.charts.defaultYLabel': 'Untitled axis',
  'extension.charts.extensionTitle': 'Chart',
  'extension.charts.height': 'Plot area height',
  'extension.charts.height.large': 'Taller',
  'extension.charts.height.medium': 'Default',
  'extension.charts.height.small': 'Shorter',
  'extension.charts.horizontal.orientation.label': 'Horizontal',
  'extension.charts.insert.tooltip': 'Insert chart',
  'extension.charts.legend': 'Legend',
  'extension.charts.legend.auto': 'Auto',
  'extension.charts.legend.bottom': 'Bottom',
  'extension.charts.legend.left': 'Left',
  'extension.charts.legend.position': 'Legend Position',
  'extension.charts.legend.right': 'Right',
  'extension.charts.legend.show': 'Show legend',
  'extension.charts.legend.top': 'Top',
  'extension.charts.options.label': 'Chart options',
  'extension.charts.options.tooltip': 'Change chart options',
  'extension.charts.orientation.label': 'Orientation',
  'extension.charts.seriesNames': 'Data series',
  'extension.charts.showPoints': 'Show data points',
  'extension.charts.smoothLines': 'Smooth lines',
  'extension.charts.style': 'Style',
  'extension.charts.title': 'Title',
  'extension.charts.type.bar': 'Bar',
  'extension.charts.type.fieldDescription': 'Chart type',
  'extension.charts.type.line': 'Line',
  'extension.charts.type.pie': 'Pie',
  'extension.charts.userTitle': 'Title',
  'extension.charts.vertical.orientation.label': 'Vertical',
  'extension.charts.xAxis': 'X-axis',
  'extension.charts.xLabel': 'X-axis label',
  'extension.charts.yLabel': 'Y-axis label',
};
